import { render, staticRenderFns } from "./ProjectPointStatistics.vue?vue&type=template&id=25e3df0e&scoped=true&"
import script from "./ProjectPointStatistics.vue?vue&type=script&lang=js&"
export * from "./ProjectPointStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPointStatistics.vue?vue&type=style&index=0&id=25e3df0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3df0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
